module.exports = __webpack_public_path__ + "img/map-pin-location.30582ed3.svg";